export default "__VITE_ASSET__C4$TTGRm__"